"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _reactRouterDom = require("react-router-dom");

/**
 * Automatically scrolls to an elemtn with an id that matches a hash within a URL.
 * @param {history} history The browser history object. Uses
 * whatever react router passes into it.
 * @package
 */
var ScrollToElement = function ScrollToElement(_ref) {
  var history = _ref.history;

  var stripHash = function stripHash(hash) {
    return hash.split("#")[1];
  };

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll(hash) {
      if (typeof window !== "undefined" && !!hash) {
        var id = stripHash(hash); // WARNING: HACK ALERT
        // Forcibly wait for the new page to be
        // rendered before executing a scroll

        setTimeout(function () {
          var el = document.getElementById(id);
          el.scrollIntoView();
        }, 100);
      }
    };

    history.listen(function (historyEvent) {
      return handleScroll(historyEvent.hash);
    });
  }, [history]);
  return null;
};

var _default = (0, _reactRouterDom.withRouter)(ScrollToElement);

exports["default"] = _default;